






















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import vueformmodel from '../../../lib/vueformmodel';
import { FormItem } from 'view-design';
import log from '@/components/log.vue';
@Component({ components: { log } })
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    model: proxy.PayUnusalOrderDto = new proxy.PayUnusalOrderDto();
    payChannels = [];

    get prox() {
        return new proxy.PayUnusalOrderServiceProxy();
    }

    save(e) {

        (this.$refs.roleForm as any).validate(async (valid: boolean) => {
            if (valid) {
                // this.prox.orderSubmit(this.orderReq).then(() => {
                //     (this.$refs.roleForm as any).resetFields();
                //     this.$Notice.success({ title: '提交成功' });
                //     this.$emit('save-success',e);
                //     this.$emit('input', false);
                // });
            }
        });
    }
    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {

            this.prox.queryModel(this.id).then(x => {
                this.model = x;
                this.querylog(this.id, 52);
            });

        }
    }

    roleRule = {
        suppName: [
            {
                required: true,
                message: this.L('FieldIsRequired'),
                trigger: 'blur'
            }
        ]
    };
}
